import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11 3.667c-.639 0-1.271-.24-1.662-.745l-.326-.42a2 2 0 0 0-2.58-.508l-.946.546a2 2 0 0 0-.852 2.49l.201.49c.242.592.135 1.257-.185 1.81v0c-.32.553-.845.984-1.478 1.07l-.526.072a2 2 0 0 0-1.73 1.982v1.092a2 2 0 0 0 1.73 1.982l.526.071c.633.086 1.157.518 1.478 1.07v0c.32.554.427 1.218.185 1.81l-.2.492a2 2 0 0 0 .85 2.488l.946.546a2 2 0 0 0 2.581-.507l.325-.42c.392-.505 1.024-.745 1.663-.745v0c.639 0 1.271.24 1.663.745l.325.42a2 2 0 0 0 2.58.507l.946-.546a2 2 0 0 0 .852-2.488l-.201-.492c-.242-.592-.135-1.256.186-1.81v0c.32-.552.845-.984 1.477-1.07l.526-.072a2 2 0 0 0 1.73-1.981v-1.092a2 2 0 0 0-1.73-1.982l-.526-.071c-.633-.087-1.157-.518-1.477-1.07v0c-.32-.554-.428-1.218-.186-1.81l.2-.492a2 2 0 0 0-.85-2.488l-.946-.546a2 2 0 0 0-2.581.507l-.325.42c-.392.505-1.024.745-1.663.745v0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.75 11a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z"
    />
  </svg>
)
export default SvgComponent
